var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-581f711e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/navItem.vue
// module id = 826
// module chunks = 245